import axios from "./axios_config";
import axios_cms from "./axios_cms";
import errorHandling from "./error_handling";

export {
    axios,
    axios_cms,
    errorHandling,
}